import { useCallback } from 'react';
import { useServices } from '@/contexts/app-services';
import type { HigherPeriod, Period } from '@/entities/types';

export function useSeenStatus(
  period: Period,
  startAtLocal: string,
): { isSeen: boolean; markSeen: () => void } {
  const { localStorage } = useServices();

  const markSeen = useCallback(() => {
    if (period === 'day') {
      return;
    }
    localStorage.markPeriodSeen(period, startAtLocal);
  }, [localStorage, period, startAtLocal]);

  if (period === 'day') {
    return { isSeen: false, markSeen };
  }

  return {
    isSeen: localStorage.isPeriodSeen(period, startAtLocal),
    markSeen,
  };
}

export function useSeenStatuses(
  checks: Array<{ period: HigherPeriod; startAtLocal: string }>,
): Record<HigherPeriod, boolean> {
  const { localStorage } = useServices();
  const result: Record<HigherPeriod, boolean> = { year: false, quarter: false, week: false };
  for (const { period, startAtLocal } of checks) {
    result[period] = localStorage.isPeriodSeen(period, startAtLocal);
  }
  return result;
}
